const video = () => {
  // cache nodes
  let embed

  const buttons = {
    start: document.querySelector('[data-video-play]'),
    stop: document.querySelector('[data-video-stop]')
  }

  const player = document.querySelector('[data-video-player]')

  // helper to asynchronously load the YouTube Player API
  const inject = () => {
    const node = document.createElement('script')
    node.setAttribute('src', 'https://www.youtube.com/iframe_api')
    document.body.appendChild(node)
  }

  // define player onReady handler
  const onReady = () => {
    // open the player
    window.requestAnimationFrame(() => player.classList.add('is-active'))

    // play when loaded
    embed.playVideo()
  }

  // define start button click handler
  const start = e => {
    e.preventDefault()
    // get ID from data attribute
    const id = player.getAttribute('data-video-id')

    // create player instance
    // eslint-disable-next-line no-undef
    embed = new YT.Player('embed', {
      videoId: id,
      playerVars: {
        rel: 0
      },
      events: {
        onReady
      }
    })
  }

  // define stop button click handler
  const stop = e => {
    e.preventDefault()
    // close the player
    window.requestAnimationFrame(() => player.classList.remove('is-active'))

    // destroy the player
    embed.destroy()
  }

  // bind event handler
  buttons.start.addEventListener('click', start)
  buttons.stop.addEventListener('click', stop)

  // inject script
  inject()
}

export default video
